module.exports = __webpack_public_path__ + "static/img/brentford-logo.af19858.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brentford-logo.svg
// module id = xEMG
// module chunks = 94